import React from "react";
import { Box, Typography, Grid, List, ListItem, ListItemText, Button } from "@mui/material";
import { styled } from "@mui/system";

const jobList = [
  {
    title: "Frontend Developer",
    location: "Remote",
    description: "As a Frontend Developer, you will work with React.js and Material UI to create modern and responsive UIs.",
  },
  {
    title: "Backend Developer",
    location: "Work from Home",
    description: "Responsible for building scalable APIs and backend services using Node.js and MongoDB.",
  },
  {
    title: "UI/UX Designer",
    location: "Hybrid",
    description: "Design intuitive and user-friendly interfaces and improve user experience across our platforms.",
  },
  {
    title: "3D Video Animation",
    location: "Office",
    description: "Create 3D animations highlighting the journey, growth, and impact of our programs.",
  },
  {
    title: "Graphic Designer",
    location: "Remote",
    description: "Design graphics and visual content that effectively promote our internship and job programs.",
  },
  {
    title: "Content Writer",
    location: "Hybrid",
    description: "Write engaging content that communicates our brand's mission, opportunities, and success stories.",
  },
];

const Background = styled(Box)(() => ({
  background: "#fff",
  minHeight: "100vh",
  padding: "40px 20px",
}));

const Sidebar = styled(Box)(() => ({
  padding: "20px",
  background: "#D9D9D9", // Aluminium color
  borderRadius: "10px",
  minHeight: "300px",
  color: "#000",
}));

const CareerPage = () => {
  const positions = [...new Set(jobList.map(job => job.title))];
  const locations = [...new Set(jobList.map(job => job.location))];

  return (
    <Background>
      {/* Heading Section */}
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Typography variant="h3" sx={{ fontWeight: 700, color: "#000" }}>
          Join Our Dynamic Team
        </Typography>
        <Typography variant="h6" sx={{ color: "#555", mt: 1 }}>
          Explore exciting career opportunities and make an impact with us.
        </Typography>
      </Box>

      {/* Main Layout */}
      <Grid container spacing={4}>
        {/* Left Sidebar - Positions */}
        <Grid item xs={12} md={2.5}>
          <Sidebar>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Positions
            </Typography>
            <List dense>
              {positions.map((pos, i) => (
                <ListItem key={i}>
                  <ListItemText primary={pos} sx={{ color: "#000" }} />
                </ListItem>
              ))}
            </List>
          </Sidebar>
        </Grid>

        {/* Center Content - Job Descriptions */}
        <Grid item xs={12} md={5.5}>
          <Box>
            {jobList.map((job, i) => (
              <Box key={i} sx={{ mb: 4 }}>
                <Typography variant="h5" sx={{ fontWeight: 600, color: "#222" }}>
                  {job.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "#777", mb: 1 }}>
                  Location: {job.location}
                </Typography>
                <Typography variant="body1" sx={{ color: "#444", lineHeight: 1.8 }}>
                  {job.description}
                </Typography>
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Right Sidebar - Locations */}
        <Grid item xs={12} md={4}>
          <Sidebar>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Locations
            </Typography>
            <List dense>
              {locations.map((loc, i) => (
                <ListItem key={i}>
                  <ListItemText primary={loc} sx={{ color: "#000" }} />
                </ListItem>
              ))}
            </List>
          </Sidebar>
        </Grid>
      </Grid>

      {/* Apply Now Button */}
      <Box sx={{ textAlign: "center", mt: 6 }}>
        <Button
          variant="contained"
          color="#F19F4D"
          sx={{ backgroundColor: "#F19F4D", borderRadius: "25px", px: 4, py: 1, fontWeight: 600 }}
          onClick={() => window.open("https://forms.gle/822zscpvEtZX6X1X8", "_blank")}
        >
          Apply Now
        </Button>
      </Box>
    </Background>
  );
};

export default CareerPage;
